import ApiConstant from "../../constants/api.constants";
import api from "../api";

const getAllDesignations = async () => {
  try {
    const result = await api.get(ApiConstant.getAllDesignations);
    return result?.data ?? [];
  } catch (error) {
    console.error("Error fetching all designations:", error);
    return [];
  }
};

const addRole = async (roleData: any) => {
  try {
    const result = await api.post(ApiConstant.addRole, roleData); 
    return result?.data ?? null;
  } catch (error) {
    console.error("Error adding role:", error);
    return null;
  }
};
const deleteRole = async (userId: number) => {
  try {
    const result = await api.delete(ApiConstant.deleteDesiriRole, {
      params: { userId },
    });
    return result?.data ?? { isSuccess: false, message: "Unknown error" };
  } catch (error) {
    console.error(`Error deleting user ${userId}:`, error);
    return { isSuccess: false, message: "Error deleting user" };
  }
};
const updateRole = async (updatedRecord: any) => {
  try {
    const res = await api.put(ApiConstant.updateDesiriRole, updatedRecord);
     return res.data; 
  } catch (error) {
    console.error("Error updating Desiri user:", error);
    return { isSuccess: false, message: "Error updating Desiri user" };
  }
};
const designationService = {
  getAllDesignations,
  addRole,
  deleteRole,
  updateRole
};

export default designationService;
